import React from "react";
import PropTypes from "prop-types";

const CustomSlider = ({ value, min, max, step, onChange, ariaLabel }) => {
  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    if (onChange) {
      onChange(e, newValue);
    }
  };

  return (
    <div className="custom-slider-container">
      <input
        type="range"
        className="custom-slider"
        value={value}
        min={min}
        max={max}
        step={step}
        aria-label={ariaLabel}
        onChange={handleChange}
      />
      {/* <div className="custom-slider-label">{value.toFixed(1)}</div> */}
    </div>
  );
};

CustomSlider.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

CustomSlider.defaultProps = {
  ariaLabel: "custom-slider",
};

export default CustomSlider;
